import {inArray} from "./helpers";

export enum Comparator {
    EXISTS = 'EXISTS',
    NOT_EXISTS = 'NOT_EXISTS',
    EQUALS = 'EQUALS',
    NOT_EQUALS = 'NOT_EQUALS',
    IN = 'IN',
    NOT_IN = 'NOT_IN',
    HAS = 'HAS',
    NOT_HAS = 'NOT_HAS',
    GREATER_THAN = '>',
    GREATER_THAN_OR_EQUAL = '>=',
    SMALLER_THAN = '<',
    SMALLER_THAN_OR_EQUAL = '<=',
}

export type RuleValue = string | boolean | Number | Array<string | Number> | null

export type RuleLikeObject = {
    key: string,
    comparator: string,
    value: RuleValue,
    strict: boolean | undefined,
}

export interface RuleMatches {
    matches(form: JQuery<HTMLFormElement>): boolean
}

export default class Rule implements RuleMatches {
    constructor(
        public readonly key: string,
        public readonly comparator: Comparator,
        public readonly value: RuleValue = null,
        public readonly strict: boolean = false,
    ) {
    }

    static fromObject(item: RuleLikeObject): Rule {
        return new Rule(item.key, Comparator[item.comparator as keyof typeof Comparator], item.value, item.strict || false)
    }

    public matches(form: JQuery<HTMLFormElement>): boolean {
        const value = this.getValue(form)

        if (this.comparator === Comparator.EXISTS) {
            return !!value
        }
        if (this.comparator === Comparator.NOT_EXISTS) {
            return !value
        }

        if (this.comparator === Comparator.EQUALS) {
            if (this.strict) {
                return value === this.value
            }

            return value == this.value
        }
        if (this.comparator === Comparator.NOT_EQUALS) {
            if (this.strict) {
                return value !== this.value
            }

            return value != this.value
        }

        if (this.comparator === Comparator.IN) {
            return inArray(value, this.value, this.strict)
        }
        if (this.comparator === Comparator.NOT_IN) {
            return inArray(value, this.value, this.strict)
        }

        if (this.comparator === Comparator.HAS) {
            return inArray(this.value, value, this.strict);
        }
        if (this.comparator === Comparator.NOT_HAS) {
            return !inArray(this.value, value, this.strict);
        }

        if (this.comparator === Comparator.GREATER_THAN) {
            return value > this.value;
        }
        if (this.comparator === Comparator.GREATER_THAN_OR_EQUAL) {
            return value >= this.value;
        }
        if (this.comparator === Comparator.SMALLER_THAN) {
            return value < this.value;
        }
        if (this.comparator === Comparator.SMALLER_THAN_OR_EQUAL) {
            return value <= this.value;
        }

        return true
    }

    protected getValue(form: JQuery<HTMLFormElement>): RuleValue {
        const field = form.find('#' + this.key)
        if (field.length < 1) {
            return null
        }

        const textarea = field.find('textarea')
        if (textarea.length > 0) {
            return textarea.val()
        }

        const select = field.find('select')
        if (select.length > 0) {
            return select.val()
        }

        const checkboxes = field.find('input[type="checkbox"]')
        if (checkboxes.length > 0) {
            return checkboxes.filter(':checked').toArray().map((el: HTMLInputElement) => el.value)
        }

        const radios = field.find('input[type="radio"]')
        if (radios.length > 0) {
            return radios.filter(':checked').val()
        }

        return field.find('input').val()
    }
}
